(function() {
  function initCollectionList(section) {
    if (!section || section.getAttribute('data-collection-list-ready') === 'true') return;

    var vibeBar = section.querySelector('[data-vibe-bar]');
    var grid = section.querySelector('[data-collection-grid]');
    if (!vibeBar || !grid) return;

    var countEl = section.querySelector('[data-collection-count]');
    var titleEl = section.querySelector('[data-collection-title]');
    var emptyEl = section.querySelector('[data-collection-empty]');
    var clearBtn = section.querySelector('[data-clear-filter]');
    var allCards = Array.prototype.slice.call(grid.querySelectorAll('[data-collection-vibes]'));

    function setActiveTab(vibe) {
      var tabs = vibeBar.querySelectorAll('[data-vibe]');
      Array.prototype.forEach.call(tabs, function(tab) {
        tab.classList.toggle('is-active', tab.getAttribute('data-vibe') === vibe);
      });
    }

    function updateTitle(vibe) {
      if (!titleEl) return;
      if (vibe === 'all') {
        titleEl.textContent = 'All Collections';
        return;
      }
      var activeTab = vibeBar.querySelector('[data-vibe="' + vibe + '"]');
      titleEl.textContent = activeTab ? activeTab.textContent : 'All Collections';
    }

    function updateBadges(vibe) {
      var activeTabLabel = '';
      if (vibe !== 'all') {
        var activeTab = vibeBar.querySelector('[data-vibe="' + vibe + '"]');
        if (activeTab) activeTabLabel = activeTab.textContent.trim();
      }

      allCards.forEach(function(card) {
        var badge = card.querySelector('[data-vibe-badge]');
        if (!badge) return;
        badge.textContent = vibe === 'all' ? badge.getAttribute('data-vibe-badge') : activeTabLabel;
      });
    }

    function updateVisibleCards(vibe) {
      var visibleCount = 0;
      allCards.forEach(function(card) {
        var shouldShow = vibe === 'all';
        if (!shouldShow) {
          var cardVibes = card.getAttribute('data-collection-vibes');
          shouldShow = !!(cardVibes && cardVibes.indexOf(vibe) !== -1);
        }

        card.classList.toggle('is-hidden', !shouldShow);
        if (shouldShow) visibleCount++;
      });

      if (countEl) countEl.textContent = visibleCount;
      if (emptyEl) emptyEl.style.display = visibleCount === 0 ? '' : 'none';

      if (window.lazySizes) {
        window.lazySizes.autoSizer.checkElems();
      }
      window.dispatchEvent(new Event('scroll'));
    }

    function scrollActiveTabIntoView(vibe) {
      var activeTab = vibeBar.querySelector('[data-vibe="' + vibe + '"]');
      if (!activeTab) return;
      var barRect = vibeBar.getBoundingClientRect();
      var tabRect = activeTab.getBoundingClientRect();
      var scrollLeft = activeTab.offsetLeft - (barRect.width / 2) + (tabRect.width / 2);
      vibeBar.scrollTo({ left: Math.max(0, scrollLeft), behavior: 'smooth' });
    }

    function filterByVibe(vibe, updateUrl) {
      setActiveTab(vibe);
      updateTitle(vibe);
      updateBadges(vibe);
      updateVisibleCards(vibe);
      scrollActiveTabIntoView(vibe);

      if (updateUrl) {
        var url = new URL(window.location.href);
        if (vibe === 'all') {
          url.searchParams.delete('vibe');
        } else {
          url.searchParams.set('vibe', vibe);
        }
        history.replaceState(null, '', url.toString());
      }
    }

    vibeBar.addEventListener('click', function(e) {
      var tab = e.target.closest('[data-vibe]');
      if (!tab || !vibeBar.contains(tab)) return;
      filterByVibe(tab.getAttribute('data-vibe'), true);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        filterByVibe('all', true);
      });
    }

    var urlParams = new URLSearchParams(window.location.search);
    var initialVibe = urlParams.get('vibe');
    if (initialVibe && vibeBar.querySelector('[data-vibe="' + initialVibe + '"]')) {
      filterByVibe(initialVibe, false);
    } else if (countEl) {
      countEl.textContent = allCards.length;
    }

    section.setAttribute('data-collection-list-ready', 'true');
  }

  function initAllCollectionLists() {
    var sections = document.querySelectorAll('[data-section-type="list-collections-template"]');
    Array.prototype.forEach.call(sections, initCollectionList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCollectionLists);
  } else {
    initAllCollectionLists();
  }

  document.addEventListener('shopify:section:load', function(event) {
    initCollectionList(event.target.querySelector('[data-section-type="list-collections-template"]'));
  });
})();
